import React from "react"
import PropTypes from "prop-types"
import { Strong, Title } from "../../../Typography/Typography"
import { providerListHeading } from "./styles.module.scss"

const pluralise = (count, plural, singular) => (count === 1 ? singular : plural)

const pageTypeCopy = (pageType, careTypeCount) => {
  switch (pageType) {
    case "home_care":
      return pluralise(careTypeCount, "home care agencies", "home care agency")
    case "care_home":
      return pluralise(careTypeCount, "care homes", "care home")
    case "dementia":
      return pluralise(
        careTypeCount,
        "dementia care homes",
        "dementia care home",
      )
    case undefined:
      return pluralise(careTypeCount, "care providers", "care provider")
    default:
      return null
  }
}

const ProviderListHeading = ({ locationName, pageType, careTypeCount }) => (
  <Title noMarginBottom className={providerListHeading}>
    {locationName} {pageTypeCopy(pageType, careTypeCount)}
    <Strong large semibold>
      {" "}
      ({careTypeCount})
    </Strong>
  </Title>
)

export default ProviderListHeading

ProviderListHeading.propTypes = {
  locationName: PropTypes.string.isRequired,
  pageType: PropTypes.oneOf(["home_care", "care_home", "dementia"]),
  careTypeCount: PropTypes.number,
}

ProviderListHeading.defaultProps = {
  careTypeCount: 0,
  pageType: undefined,
}
